'use strict';

angular.module('app.mentionDetail', [])
    .controller('mentionDetailCtrl', ['$scope', '$rootScope', '$modal', '$http', 'mentionDetailService', '$modalInstance', 'mentionManagementService', 'newMentionsService',
        function ($scope, $rootScope, $modal, $http, mentionDetailService, $modalInstance, mentionManagementService, newMentionsService) {
            $scope.modalInstance = $modalInstance;
            $scope.selectedTopicRow = null;
            $scope.checkedTopicRow = null;
            $scope.selectedVerticalRow = null;
            $scope.checkedVerticalRow = null;
            $scope.translatedMentionList = [];
            $scope.newMentionNameList = [];
            $scope.newLanguageIdList = [];
            $scope.specificMentionLanguage = false;
            $scope.enableWatch = false;
            $scope.sameLangague = false;

            $scope.detail_topics = [];
            var topicObject = {
                id: 1,
                name: "No Topic"
            }

            $scope.detail_verticals = [];
            var verticalObject = {
                id: 1,
                name: "No Industry"
            }

            mentionManagementService.getLanguagesOfInterestingCountries(false)
                .then(function (response) {
                    $scope.detail_Languages = response.data;
                }, function (errResponse) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = errResponse.message;
                })

            $scope.detail_topics.push(topicObject);
            var url_getMentionDetailTopic = $rootScope.apiUrl + 'mention/getAllTopic';
            $http.get(url_getMentionDetailTopic, {
                    loader: false
                })
                .success(function (responseGetMentionDetailTopic) {
                    angular.forEach(responseGetMentionDetailTopic.data, function (itemTopic) {
                        itemTopic.ticked = false;
                        $scope.detail_topics.push(itemTopic);
                    })
                    var url_getMentionDetailVertical = $rootScope.apiUrl + 'mention/getAllVertical';
                    $http.get(url_getMentionDetailVertical, {
                            loader: false
                        })
                        .success(function (responseGetMentionDetailVertical) {
                            angular.forEach(responseGetMentionDetailVertical.data, function (itemVertical) {
                                itemVertical.ticked = false;
                                $scope.detail_verticals.push(itemVertical);
                            })
                            loadMentionDetailData();
                        })
                })

            function loadMentionDetailData() {
                var url_getMentionByID = $rootScope.apiUrl + 'mention/getMentionById/' + $scope.id;
                $http.get(url_getMentionByID, {
                        loader: false
                    })
                    .success(function (responseGetMentionById) {

                        $scope.mentionDetail = responseGetMentionById.data;
                        $scope.keyword = responseGetMentionById.data.keyword;
                        $scope.oldKeyword = responseGetMentionById.data.keyword;
                        $scope.mentionId = responseGetMentionById.data.id;
                        $scope.groupId = responseGetMentionById.data.group_keyword_id;
                        $scope.lastSearched = responseGetMentionById.data.last_searched;
                        $scope.instagram_influencer_search = responseGetMentionById.data.instagram_influencer_search == 1 ? true : false;

                        $scope.disableLanguages = false;
                        if ($scope.mentionDetail.keywordType.id == 1) {
                            $scope.disableLanguages = false;
                        } else {
                            $scope.disableLanguages = true;
                        }

                        var url_getMentionDetailKeywordType = $rootScope.apiUrl + 'mention/getKeywordType';
                        $http.get(url_getMentionDetailKeywordType, {
                                loader: false
                            })
                            .success(function (responseGetMentionDetailKeywordType) {
                                $scope.detail_types = responseGetMentionDetailKeywordType.data;
                                $scope.detail_types.forEach(function (valKeywordType) {
                                    if (valKeywordType.name == "Url") {
                                        valKeywordType.name = "URL";
                                    }
                                    if (valKeywordType.name == "Hash") {
                                        valKeywordType.name = "Hashtag";
                                    }
                                    if (valKeywordType.id == $scope.mentionDetail.keywordType.id) {
                                        valKeywordType.ticked = true;
                                        $scope.selectedType = valKeywordType.name;
                                    }
                                })
                                if ($scope.mentionDetail.keywordType.id == 1) {
                                    $scope.mention_type_icon = "/images/ico/keyword.gif";
                                } else if ($scope.mentionDetail.keywordType.id == 2) {
                                    $scope.mention_type_icon = "/images/ico/url.gif";
                                } else if ($scope.mentionDetail.keywordType.id == 3) {
                                    $scope.mention_type_icon = "/images/ico/hash.gif";
                                }

                                var url_getMentionDetailKeywordApproval = $rootScope.apiUrl + 'mention/getKeywordApproval';
                                $http.get(url_getMentionDetailKeywordApproval, {
                                        loader: false
                                    })
                                    .success(function (responseGetMentionDetailKeywordApproval) {
                                        $scope.keyword_approval = responseGetMentionDetailKeywordApproval.data;
                                        $scope.keyword_approval.forEach(function (valKeywordApproval) {
                                            if (valKeywordApproval.id == $scope.mentionDetail.approved) {
                                                valKeywordApproval.ticked = true;
                                            }
                                        })

                                        if ($scope.mentionDetail.is_global == 1) {
                                            $scope.specificLanguage = $scope.detail_Languages[0];
                                            $scope.detail_Languages[0].ticked = true;
                                        } else {
                                            angular.forEach($scope.mentionDetail.languages, function (resultLanguage) {
                                                angular.forEach($scope.detail_Languages, function (itemAllLanguage) {
                                                    if (itemAllLanguage.name == resultLanguage.name) {
                                                        $scope.specificLanguage = itemAllLanguage;
                                                        itemAllLanguage.ticked = true;
                                                    }
                                                })
                                            })
                                        }

                                        if ($scope.mentionDetail.topic.length != 0) {
                                            $scope.selectedTopicRow = $scope.mentionDetail.topic[0].id;
                                            $scope.detail_topics.forEach(function (topicItem) {
                                                if (topicItem.id == $scope.selectedTopicRow) {
                                                    topicItem.ticked = true;
                                                }
                                            })
                                        }
                                        if ($scope.mentionDetail.vertical.length != 0) {
                                            $scope.selectedVerticalRow = $scope.mentionDetail.vertical[0].id;
                                            $scope.detail_verticals.forEach(function (verticalItem) {
                                                if (verticalItem.id == $scope.selectedVerticalRow) {
                                                    verticalItem.ticked = true;
                                                }
                                            })
                                        }

                                        if ($scope.specificLanguage.name != "Global") {
                                            $scope.specificMentionLanguage = true;
                                            var data = {
                                                group_keyword_id: $scope.groupId
                                            }
                                            var req = {
                                                url: $rootScope.apiUrl + "mention/translatedMentions",
                                                method: 'POST',
                                                data: JSON.stringify(data),
                                                loader: false
                                            }

                                            $http(req).success(function (responseGetTransaltedMentions) {
                                                $scope.mentionList = responseGetTransaltedMentions.data;
                                                $scope.mentionList.forEach(function (itemTranslatedKeyword) {
                                                    if (itemTranslatedKeyword.languages[0].name != $scope.specificLanguage.name) {
                                                        $scope.translatedMentionList.push(itemTranslatedKeyword);
                                                    }

                                                })
                                                $scope.enableWatch = true;
                                            })
                                        } else {
                                            $scope.specificMentionLanguage = false;
                                            $scope.enableWatch = true;
                                        }
                                    })
                            })
                    })
            }

            $scope.hashtagScan = function () {
                console.log($scope.is_hashtag_scan);
            }

            $scope.deleteMention = function (id) {

                var deleteConfirmModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/mention/mentions/mentionDetail/deleteMention/deleteMention.html?app_v=deployDate',
                    controller: 'deleteMentionCtrl',
                    id: id
                });

                $scope.mentionDetailsModalInstance;
                $scope.deleteConfirmModalInstance = deleteConfirmModalInstance;
            }

            $scope.updateMention = function (id) {
                $scope.selectedLanguageId = [];
                $scope.detail_Languages.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedLanguageId.push(val.id)
                });

                $scope.selectedApproval = "";
                $scope.keyword_approval.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedApproval = val.id;
                });

                $scope.selectedType = "";
                $scope.detail_types.forEach(function (val) {
                    if (val.ticked === true)
                        $scope.selectedType = val.id;
                });

                $scope.selectedTopic = "";
                $scope.detail_topics.forEach(function (topicVal) {
                    if (topicVal.ticked === true)
                        $scope.selectedTopic = topicVal.id;
                });

                $scope.selectedVertical = "";
                $scope.detail_verticals.forEach(function (verticalVal) {
                    if (verticalVal.ticked === true)
                        $scope.selectedVertical = verticalVal.id;
                });

                var data = {
                    keyword: $scope.keyword,
                    keywordType: $scope.selectedType,
                    approved: $scope.selectedApproval,
                    languages: $scope.selectedLanguageId,
                    topic_id: $scope.selectedTopic,
                    vertical_id: $scope.selectedVertical,
                    group_keyword_id: $scope.groupId,
                    newMentionNames: $scope.newMentionNameList,
                    newLanguageIds: $scope.newLanguageIdList,
                    instagram_influencer_search: $scope.instagram_influencer_search
                }

                if (!$scope.sameLangague) {
                    if ($scope.keyword != $scope.oldKeyword ||
                        ($scope.mentionDetail.languages[0].id != $scope.selectedLanguageId[0] && $scope.mentionDetail.is_global == 0) ||
                        ($scope.mentionDetail.is_global == 1 && $scope.selectedLanguageId[0] != 0)) {
                        $scope.checkKeyword = encodeURIComponent($scope.keyword);
                        newMentionsService.checkNewMention($scope.checkKeyword, $scope.selectedLanguageId[0], "update", true)
                            .then(function (responseCheckNewMentionForUpdate) {
                                mentionDetailService.updateMention(id, data, true)
                                    .then(function (responseUpdateMention) {
                                        if($scope.mentionManagementLogMentionDetailsModalInstance == undefined &&
                                            $scope.mentionManagementLogDetailedModalInstance == undefined) {
                                            $modalInstance.close(function () {
                                                $log.info('Close Modal now');
                                            })
                                            $scope.loadData();
                                        } else if($scope.mentionManagementLogMentionDetailsModalInstance != undefined) {
                                            $scope.mentionManagementLogMentionDetailsModalInstance.close();
                                        } else if($scope.mentionManagementLogDetailedModalInstance != undefined) {
                                            $scope.mentionDetailsModalInstance.close();
                                            $scope.mentionManagementLogDetailedModalInstance.close();
                                        }
                                    }, function (responseUpdateMention) {
                                        var errorModalInstance = $modal.open({
                                            scope: $scope,
                                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                            windowClass: 'modal-dialog-mention-error'
                                        });
                                        $scope.errorModalInstance = errorModalInstance;
                                        $scope.errorMessage = responseUpdateMention.message;
                                    })
                            }, function (responseCheckNewMentionForUpdate) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseCheckNewMentionForUpdate.message;
                            })
                    } else {
                        mentionDetailService.updateMention(id, data, true)
                            .then(function (responseUpdateMention) {
                                if($scope.mentionManagementLogMentionDetailsModalInstance == undefined &&
                                    $scope.mentionManagementLogDetailedModalInstance == undefined) {
                                    $modalInstance.close(function () {
                                        $log.info('Close Modal now');
                                    })
                                    $scope.loadData();
                                } else if($scope.mentionManagementLogMentionDetailsModalInstance != undefined) {
                                    $scope.mentionManagementLogMentionDetailsModalInstance.close();
                                } else if($scope.mentionManagementLogDetailedModalInstance != undefined) {
                                    $scope.mentionDetailsModalInstance.close();
                                    $scope.mentionManagementLogDetailedModalInstance.close();
                                }
                            }, function (responseUpdateMention) {
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = responseUpdateMention.message;
                            })
                    }
                } else {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = "This Mention has the same language with Translation Mention";
                }
            }

            $scope.updateModifiedAt = function (id) {
                var req = {
                    url: $rootScope.apiUrl + 'mention/updateModifiedAt/' + id,
                    method: 'GET',
                    loader: false
                }

                $http(req).success(function (responseUpdateMention) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/successMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = "Successfully! The mention will be included in Twingly execution tomorrow";
                    })
                    .error(function (data) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = data.message;
                    });
            }

            $scope.$watch('selectedLanguage', function (newValue, oldValue) {
                if (newValue !== oldValue && newValue !== undefined && $scope.enableWatch) {
                    $scope.sameLangague = false;
                    if (newValue[0].id == 0) {
                        $scope.specificMentionLanguage = false;
                    } else {
                        $scope.specificMentionLanguage = true;
                        $scope.translatedMentionList.forEach(function (translatedMention) {
                            if (translatedMention.languages[0].id == newValue[0].id) {
                                $scope.sameLangague = true;
                                var errorModalInstance = $modal.open({
                                    scope: $scope,
                                    templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                                    windowClass: 'modal-dialog-mention-error'
                                });
                                $scope.errorModalInstance = errorModalInstance;
                                $scope.errorMessage = "This Mention has the same language with Translation Mention";
                            }
                        })
                    }
                }
            });

            $scope.newLanguageModalHandler = function () {
                var newLanguageModalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/mention/mentions/mentionDetail/addNewTranslation/addNewTranslation.html?app_v=deployDate',
                    controller: 'addNewTranslationCtrl'
                });

                $scope.newLanguageModalInstance = newLanguageModalInstance;
                $scope.mention_id = $scope.mentionId;
                $scope.mention_language_id = $scope.specificLanguage.id;
                $scope.currentTranslation = [];
                angular.forEach($scope.translatedMentionList, function (currentTranslate) {
                    $scope.currentTranslation.push(currentTranslate.languages[0].id);
                })

                newLanguageModalInstance.result.then(function (result) {
                    if ($scope.translatedMentionList) {
                        $scope.translatedMentionList.push(result.newMention);
                        $scope.newMentionNameList.push(result.newMention.keyword);
                        $scope.newLanguageIdList.push(result.newMention.languages[0].id);
                    }
                }, function () {

                });
            }
        }
    ])